import { render, staticRenderFns } from "./PartnerAdmin.vue?vue&type=template&id=5f743236&scoped=true"
import script from "./PartnerAdmin.vue?vue&type=script&lang=js"
export * from "./PartnerAdmin.vue?vue&type=script&lang=js"
import style0 from "./PartnerAdmin.vue?vue&type=style&index=0&id=5f743236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f743236",
  null
  
)

export default component.exports